import React from "react";
import Link from "gatsby-link";
import logo from "../layouts/img/logo.png";
import { fetchResponseHelper, fetchErrorHelper } from "../lib/api";
import Logox2 from "../layouts/img/logox2.png";
import { Modal } from "react-bootstrap";

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      scrolling: false,
      showModal: false,
      showModal2: false,
      username: "",
      password: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  toggle(e) {
    e.preventDefault();
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  handleChange(event, value) {
    this.setState({ [value]: event.target.value });
  }

  handleScroll = () => {
    if (this.props.path === "/") {
      if (window.scrollY > 150 && this.state.scrolling !== true) {
        this.setState({ scrolling: true });
      } else if (window.scrollY < 150 && this.state.scrolling !== false) {
        this.setState({ scrolling: false });
      }
    }
  };

  handleClose() {
    this.setState({ showModal: false, showModal2: false });
  }

  handleShow(modal) {
    this.handleClose();
    this.setState({ [modal]: true });
  }

  handleSubmit(e) {
    e.preventDefault();
    fetch("https://app.swissmonkey.io/api/v2.0/user/marketing_login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password
      })
    })
      .then(fetchResponseHelper, fetchErrorHelper)
      .then(data => {
        if (data.success) {
          return (window.location.href = data.url);
        }
        return alert(data.message);
      })
      .catch(error => {
        alert(error.message);
      });
  }

  render() {
    const { path } = this.props;
    console.log("this.props.path", path);
    const shouldHideNavBar = path === "/cda2019/" || path === "/cda2019";
    return (
      <div>
        {!shouldHideNavBar && (
          <header
            id="masthead"
            className={
              this.state.scrolling || this.props.path !== "/"
                ? "site-header landing-header affix"
                : "site-header landing-header affix-top"
            }
          >
            <nav
              id="primary-navigation"
              className="site-navigation landing-navigation"
            >
              <div className="container-fluid">
                <div className="navbar-header">
                  <button
                    type="button"
                    className={
                      this.state.menuOpen
                        ? "navbar-toggle collapsed act"
                        : "navbar-toggle collapsed"
                    }
                    onClick={this.toggle}
                  >
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>

                  <Link to="/" className="navbar-brand">
                    <img src={logo} className="img-responsive" alt="" />
                  </Link>
                </div>

                <div
                  className={
                    this.state.menuOpen ? "main-menu act" : "main-menu"
                  }
                >
                  <ul className="nav navbar-nav navbar-right">
                    <li>
                      <Link
                        onClick={() =>
                          this.setState({ menuOpen: !this.state.menuOpen })
                        }
                        to="/employer"
                      >
                        EMPLOYERS
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          this.setState({ menuOpen: !this.state.menuOpen })
                        }
                        to="/jobseekers"
                      >
                        JOB SEEKER
                      </Link>
                    </li>
                    {/*
                  <li>
                    <Link onClick={() => this.setState({ menuOpen: !this.state.menuOpen })} to="/practicesupport">PRACTICE SUPPORT</Link>
                  </li>
                  */}
                    <li>
                      <Link
                        onClick={() =>
                          this.setState({ menuOpen: !this.state.menuOpen })
                        }
                        to="/contact"
                      >
                        CONTACT
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          this.setState({ menuOpen: !this.state.menuOpen })
                        }
                        to="/vendors"
                      >
                        VENDORS
                      </Link>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        onClick={() => this.handleShow("showModal2")}
                      >
                        Join
                      </a>{" "}
                    </li>
                    <li className="sign-in">
                      <a
                        href="https://app.swissmonkey.io/users/sign_in"
                        className="btn-main btn-sm btn-secondary"
                      >
                        Sign in
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </header>
        )}

        <Modal
          show={this.state.showModal2}
          id="sign-up-modal"
          className="modal-second-level"
          onHide={this.handleClose}
        >
          <Modal.Body>
            <img src={Logox2} className="modal-logo" alt="" />
            {/*<form>*/}
            {/*<div className="input-group input-group-img">*/}
            {/*<img src={EmailGray} alt="" />*/}
            {/*<input*/}
            {/*id="sign-up-email"*/}
            {/*type="text"*/}
            {/*className="form-control form-control-img "*/}
            {/*name="email"*/}
            {/*placeholder="enter valid email"*/}
            {/*/>*/}
            {/*</div>*/}
            {/*<div className="input-group input-group-img">*/}
            {/*<img src={PassGray} alt="" />*/}
            {/*<input*/}
            {/*id="sign-up-password"*/}
            {/*type="text"*/}
            {/*className="form-control form-control-img "*/}
            {/*name="password"*/}
            {/*placeholder="create password"*/}
            {/*/>*/}
            {/*</div>*/}
            {/*<div className="text-center">*/}
            {/*<p className="p-18 p-gray mt-50">or create account using</p>*/}
            {/*</div>*/}

            {/*<ul className="list-unstyled list-inline sign-up-social mt-50">*/}
            {/*<li>*/}
            {/*<a href="#">*/}
            {/*<img src={Fb} alt="" />*/}
            {/*</a>*/}
            {/*</li>*/}
            {/*<li>*/}
            {/*<a href="#">*/}
            {/*<img src={Google} alt="" />*/}
            {/*</a>*/}
            {/*</li>*/}
            {/*<li>*/}
            {/*<a href="#">*/}
            {/*<img src={Linked} alt="" />*/}
            {/*</a>*/}
            {/*</li>*/}
            {/*</ul>*/}

            <div className="text-center">
              <p className="p-18 p-gray txt-uppercase weight-bold mt-50">
                REGISTER AS
              </p>
            </div>

            <div className="row mt-50">
              <div className="col-xs-6 col-12">
                <a
                  href="https://app.swissmonkey.io/users/sign_up"
                  className="btn-main btn-secondary btn-100 thank-you-btn"
                >
                  Employer
                </a>
              </div>
              <div className="col-xs-6 col-12 mt-xs-15">
                <a
                  href="https://jobs.swissmonkey.io/register"
                  className="btn-main btn-alt btn-100 thank-you-btn"
                >
                  Job Seeker
                </a>
              </div>
            </div>
            {/*</form>*/}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js